// import moment from "moment";
import { atom } from "recoil";

export const attendanceRecordState = atom({
  key: "attendance/record/item",
  default: null,
});

export const attendanceCurriculumState = atom({
  key: "attendance/curriculum/item",
  default: { currentIndex: -1, currentItem: null },
});

export const attendanceStudentListState = atom({
  key: "attendance/student/list",
  default: [],
});
export const attendanceCurriculumListState = atom({
  key: "attendance/curriculum/list",
  default: [],
});
export const attendanceTitleState = atom({
  key: "attendance/title",
  default: "",
});
